import { render, staticRenderFns } from "./child_relatedProducts.vue?vue&type=template&id=2dd66ac2"
import script from "./child_relatedProducts.vue?vue&type=script&lang=js"
export * from "./child_relatedProducts.vue?vue&type=script&lang=js"
import style0 from "./child_relatedProducts.vue?vue&type=style&index=0&id=2dd66ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports